
export const InterviewRoute = /client\/\d+\/account\/\d+-\d+\/\d+\/interview/;
export const CaseSummaryRoute = /client\/\d+\/account\/\d+-\d+\/\d+\/.*\/summary/;
export const FileExtension = /\.([^.]+)$/;